import React from "react";
import { Switch, Route } from "react-router-dom";

import Register from "./pages/Register";
import MisPedidos from "./pages/MisPedidos";

export default function UserPage() {
  return (
    <Switch>
      <Route path="/user/" exact component={MisPedidos} />
      <Route path="/user/registrar/" exact component={Register} />
      <Route path="/user/pedidos/" exact component={MisPedidos} />
    </Switch>
  );
}
